import * as React from "react";
import { useState, useEffect, useContext } from "react";
import AddCircle from "@mui/icons-material/AddCircle";
import EraseIcon from "@mui/icons-material/Delete";
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
  Tooltip,
} from "@mui/material";
import { DataGrid, GridColumns } from "@mui/x-data-grid";
import { UserContext } from "../../App";
import Notification from "../../components/common/Notification";
import { useTranslation } from "react-i18next";

interface EmailParceiroRow {
  id: number;
  email: string;
}

interface EmailsParceiroModalProps {
  openDialog: boolean;
  setOpenDialog: any;
  emails: string[];
  setEmails: any;
}

export default function EmailsParceiroModal(props: EmailsParceiroModalProps) {
  const { t } = useTranslation();
  const user: any = useContext(UserContext);

  const [rows, setRows] = useState<EmailParceiroRow[]>([]);

  const [email, setEmail] = useState<string>("");
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const columns: GridColumns = [
    {
      field: "email",
      headerName: t("common.email"),
      flex: 1,
      editable: false,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "deleteico",
      headerAlign: "center",
      align: "center",
      headerName: t("common.delete"),
      width: 100,
      renderCell: (cellValues) => {
        return (
          <Tooltip title={t("common.delete")}>
            <span>
              <IconButton
                disabled={user.isSuporte}
                onClick={(event) => {
                  removeEmail(cellValues.row);
                }}
              >
                <EraseIcon />
              </IconButton>
            </span>
          </Tooltip>
        );
      },
    },
  ];

  const removeEmail = (row: any) => {
    props.setEmails(props.emails.filter((x) => x != row.email));
  };

  useEffect(() => {
    let count = 0;
    let rows = props.emails.map((x) => {
      return {
        id: count++,
        email: x,
      };
    });

    setRows(rows);
  }, [props.emails]);

  return (
    <>
      <Dialog
        open={props.openDialog}
        onClose={() => props.setOpenDialog(false)}
        aria-labelledby="alert-dialog-title"
      >
        <DialogTitle id="alert-dialog-title">
          {t("pages.partners.text.partnerEmails")}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={3} marginTop={1}>
            <Grid item xs={12} sm={9}>
              <TextField
                required
                //id={containerId + "email"}
                //name={containerId + "email"}
                label={t("common.email")}
                fullWidth
                variant="outlined"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                size="small"
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  props.setEmails([...props.emails, email]);
                  setEmail("");
                }}
                autoFocus
                fullWidth
              >
                {t("common.add")}
              </Button>
            </Grid>
            <Grid item xs={12}>
              <Box sx={{ height: "60vh" }}>
                <DataGrid
                  rows={rows}
                  columns={columns}
                  rowsPerPageOptions={[5, 10, 25]}
                  autoPageSize
                  disableSelectionOnClick
                />
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => props.setOpenDialog(false)}
            autoFocus
          >
            {t("common.close")}
          </Button>
        </DialogActions>
      </Dialog>
      <Notification notify={notify} setNotify={setNotify} />
    </>
  );
}
